// Reads a STARS token's computed value in JS, for libraries that take colours as
// strings (Chart.js, Highcharts). The value follows .stars-dark when `node` sits
// inside a dark region. Never hard-code a hex in a chart (spec § Ratchets, W8).
export function readToken(name, node = document.documentElement) {
  return getComputedStyle(node).getPropertyValue(`--stars-${name}`).trim();
}
